export default "__VITE_ASSET__C8z$S2rK__"